
import { Options, Vue } from "vue-class-component";
import Loading from "@/components/Loading.vue";
import { namespace } from "vuex-class";
import router from "@/router";

const SystemModule = namespace("survey");
@Options({
  components: {
    loading: Loading,
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.name === "Survey") {
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
  metaInfo: () => {
    return {
      meta: [
        {
          name: "description",
          content:
            "じぶんフォントプロジェクトは、皆が文字を読める社会の実現を目標に、みなさまに新しいフォントを体験いただきながらアンケートにお答えいただき、よりよいフォント・サービスを目指します。",
        },
        {
          name: "keywords",
          content:
            "ディスレクシア, フォント, じぶんフォント, アンケート, 読み書き困難",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
          vmid: "twitter:card",
        },
        {
          property: "og:site_name",
          content: "じぶんフォント",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:url",
          content: "https://www.jibun-font.com/survey/entrance",
          vmid: "og:url",
        },
        {
          property: "og:title",
          content: "じぶんフォントをみつける（アンケート） - じぶんフォント",
          vmid: "og:title",
        },
        {
          property: "og:image",
          content: "https://www.jibun-font.com/ogp/ogp.png",
          vmid: "og:image",
        },
        {
          property: "og:description",
          content: "Survey Description",
          vmid: "og:description",
        },
      ],
      title: "じぶんフォントをみつける（アンケート） - じぶんフォント",
      htmlAttrs: {
        lang: "ja",
      },
      noscript: [
        {
          innerHTML:
            "このWebサイトを閲覧するにはJavaScriptが必要です。 / This website requires JavaScript.",
        },
      ],
    };
  },
})
export default class Survey extends Vue {
  @SystemModule.Getter("isLoading")
  private isLoading!: boolean;

  @SystemModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  @SystemModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  public isSurveyModalActive = false;

  public switchModalStatus() {
    this.isSurveyModalActive = !this.isSurveyModalActive;
  }

  public async backPage() {
    await this.updateIsWhiteout(true);
    this.$router.go(-1);
  }

  private get isBackButtonMount() {
    return (
      this.$route.fullPath !== "/survey/exit" &&
      this.$route.fullPath !== "/survey/courtyard"
    );
  }

  private get isExitButtonMount() {
    return this.$route.fullPath !== "/survey/exit";
  }

  private fontComparePages = 21;

  private get surveyTotalPages() {
    return this.fontComparePages + this.surveyPagesDef.length;
  }

  private get surveyPages() {
    return this.surveyPagesDef.map((item) => {
      if (item.pageNumber > 5) {
        item.pageNumber = item.pageNumber + this.fontComparePages;
      }
      return item;
    });
  }

  private get surveyProgress() {
    let progress = 0;

    const pageItem = this.surveyPages.find(
      (item) => item.fullPath === this.$route.fullPath
    );
    if (pageItem) {
      progress = pageItem.pageNumber;
    }

    if (this.$route.name === "CompareFonts") {
      progress = 5 + Number(this.$route.params.id);
    }

    return progress;
  }

  private surveyPagesDef = [
    {
      pageNumber: 1,
      fullPath: "/survey/entrance",
    },
    {
      pageNumber: 2,
      fullPath: "/survey/how-old-by-age",
    },
    {
      pageNumber: 3,
      fullPath: "/survey/how-old-age",
    },
    {
      pageNumber: 4,
      fullPath: "/survey/which-layout",
    },
    {
      pageNumber: 5,
      fullPath: "/survey/which-font",
    },
    {
      pageNumber: 6,
      fullPath: "/survey/courtyard",
    },
    {
      pageNumber: 7,
      fullPath: "/survey/what-gender",
    },
    {
      pageNumber: 8,
      fullPath: "/survey/where-live-region",
    },
    {
      pageNumber: 9,
      fullPath: "/survey/where-live-province",
    },
    {
      pageNumber: 10,
      fullPath: "/survey/reading-volume",
    },
    {
      pageNumber: 11,
      fullPath: "/survey/reading-like",
    },
    {
      pageNumber: 12,
      fullPath: "/survey/reading-fatigue",
    },
    {
      pageNumber: 13,
      fullPath: "/survey/reading-speed",
    },
    {
      pageNumber: 14,
      fullPath: "/survey/reading-state",
    },
    {
      pageNumber: 15,
      fullPath: "/survey/reading-skips",
    },
    {
      pageNumber: 16,
      fullPath: "/survey/reading-line-tracking",
    },
    {
      pageNumber: 17,
      fullPath: "/survey/reading-flickering",
    },
    {
      pageNumber: 18,
      fullPath: "/survey/reading-distortions",
    },
    {
      pageNumber: 19,
      fullPath: "/survey/writing-letter-like",
    },
    {
      pageNumber: 20,
      fullPath: "/survey/writing-sentence-like",
    },
    {
      pageNumber: 21,
      fullPath: "/survey/writing-speed",
    },
    {
      pageNumber: 22,
      fullPath: "/survey/writing-care",
    },
    {
      pageNumber: 23,
      fullPath: "/survey/free-comment",
    },
  ];

  public get preloadText(): string {
    let text = this.surveyPreLoadText;
    if (this.surveyProgress > 26) {
      text = text + this.enquetePreLoadText;
    }

    return text;
  }

  public get surveyPreLoadText(): string {
    return `よみやすい「じぶんにあったフォント」を みつけよう
こどもは おとなの ひとと いっしょに やってみよう！
じぶんフォントプロジェクトは、より多くの人が文章を読める社会の実現を目標に、研究・開発を進めます。みなさまに新しいフォントを体験いただきながらアンケートにお答えいただき、個人情報を含まないアンケート結果を研究に活用し、より良いフォントの開発やサービスを目指します。
より多くの人が文章を読める社会の実現のため、多くの方のご参加をお待ちしております。
このアンケートは、年齢などの基本属性、文章を見て読みやすいと感じるフォントの選択、読書量、書字状況にボタンで回答いただく流れとなります。アンケートが終了すると、あなたに合ったフォントでサイト内の文章が表示されます。
未成年の方は保護者の同意と付き添いのもと実施してください。
スマートフォンでの回答も可能ですが、可能な場合はPCやタブレットなどの横長の画面で回答いただくことを推奨します。
体験をご利用いただくため、研究参加に関する説明書・同意書、利用規約、プライバシーポリシーへの同意をお願いします。
上記に同意してアンケートに答える
何歳(なんさい)ですか？
（9歳(さい)以下(いか)の場合(ばあい)画面(がめん)の文字(もじ)が平仮名(ひらがな)になります）
0〜9さい
10〜19才
20〜29歳
30〜39歳
40〜49歳
50〜59歳
60〜69歳
70〜79歳
80〜89歳
90〜99歳
100歳以上
すきな もじの かたちを みつける
つぎの がめんで ふたつの もじが でてきます。
ふたつの うち、すきな もじの かたちを えらんで ください。
（もじが かわるので 21かい えらんでください）
ひらがなだけのぶんしょうでえらぶ
小学3年生までに習う漢字を使った文章でえらぶ
小学6年生までに習う漢字を使った文章で選ぶ
好きな文字の形を見つける
次の画面で、同じ文章がちがう文字で並べて表示されます。
自分が「読みやすい」と感じる方を選んでください。
（文字が入れ替わるので、21回選んでください）
ひらがなだけのぶんしょうでえらぶ
小学3年生までに習う漢字を使った文章でえらぶ
小学6年生までに習う漢字を使った文章で選ぶ
よみやすいもじはどちらですか？
このもじをえらぶ
読みやすい文字はどちらですか？
この文字を選ぶ
あなたと もじの ことを おしえてください。
いま あなたが えらんだ もじが、 これから つかわれます。
つぎの がめんから、 あなたと もじの ことを おしえてください。
つぎのがめんへすすむ
あなたと文字のことを教えてください。
先ほどあなたが選んだフォント（文字）が、これから画面に使われます。
次の画面から、あなたと文字のことを教えてください。
次の画面へ進む
`;
  }

  public get enquetePreLoadText(): string {
    return `
あなたのせいべつはどれですか。
おとこ
おんな
そのほか
こたえない
性別（せいべつ）を教えてください。
男
女
そのほか
答えない
あなたのすんでいるところはどこですか。
ほっかいどう
とうほうく ちほう
かんとう ちほう
ちゅうぶ ちほう
きんき ちほう
ちゅうごく・しこく ちほう
きゅうしゅう ちほう
かいがい
こたえない
お住まいを教えてください。
北海道
東北地方
関東地方
中部地方
近畿地方
中国・四国地方
九州地方
海外
答えない
北海道-ほっかいどう

東北-とうほく
青森県-あおもり けん
岩手県-いわて けん
秋田県-あきた けん
宮城県-みやぎ けん
山形県-やまがた けん
福島県-ふくしま けん

関東-かんとう
茨城県-いばらき けん
栃木県-とちぎ けん
群馬県-ぐんま けん
埼玉県-さいたま けん
千葉県-ちば けん
東京都-とうきょう と
神奈川県-かながわ けん

中部-ちゅうぶ
新潟県-にいがた けん
富山県-とやま けん
石川県-いしかわ けん
福井県-ふくい けん
山梨県-やまなし けん
長野県-ながの けん
岐阜県-ぎふ けん
静岡県-しずおか けん
愛知県-あいち けん

近畿-きんき
滋賀県-しが けん
京都府-きょうと ふ
大阪府-おおさか ふ
兵庫県-ひょうご けん
奈良県-なら けん
三重県-みえ けん
和歌山県-わかやま けん

中国・四国-ちゅうごく・しこく
鳥取県-とっとり けん
島根県-しまね けん
岡山県-おかやま けん
広島県-ひろしま けん
山口県-やまぐち けん
徳島県-とくしま けん
香川県-かがわ けん
愛媛県-えひめ けん
高知県-こうち けん

九州-きゅうしゅう
福岡県-ふくおか けん
佐賀県-さが けん
長崎県-ながさき けん
大分県-おおいた けん
熊本県-くまもと けん
宮崎県-みやざき けん
鹿児島県-かごしま けん
沖縄県-おきなわ けん
さいきん いっかげつの あだいに なんさつ ほんを よみましたか？
0
1
2
3
4〜5
6 いじょう
最近1ヶ月の間に何冊(なんさつ)本を読みましたか？
6以上
もじを よむことが すきだ
文字を読むことが好きである
ながい ぶんしょうを よむと つかれる
長い文章を読むとつかれる
ぶんしょうを こえにだして よむのに じかんが かかる
文章の音読に時間がかかる
ぶんしょうを こえにだして よむとき、ないようが わからないことが おおい
音読時に文章の内容(ないよう)を理解(りかい)していないことが多い
もじを かくことが すきだ
文字を書くことが好きである
とても あてはまる
あてはまる
あてはまらない
まったく あてはまらない
ぶんしょうを かくことが すきだ
文章を書くことが好きである
もじを かくのに じかんが かかる
文字を書くのに時間がかかる
もじを かくのが ざつになる
文字を書くときに雑(ざつ)になってしまう
もじや ことばや ぎょうを とばして よんで しまう
文字や単語、行をとばしてしまう
おなじ ぎょうを なんども よんで しまう
同じ行を繰り返し読んでしまう
もじが ちかちかして よみにくい
文字がチカチカして読みにくい
もじが うごいて みえる
文字が動いて見える
もじを よむときに、こまっていることや くふうしていることを、おしえてください。
文字を読むときに、困っていることや工夫していることがあったら教えてください。

ご協力
おしえて
いただき、 ありがとう ございました

じぶんフォントプロジェクトでは、アンケートを
ディスレクシアの研究に役立てます。
もとに、あなたが よめる もじの かたちを かんがえます

さらにプロジェクトの活動について知りたい、参加したい場合は、
もっと「じぶんフォント」について しりたい、 てつだいたい ばあいは、

下記のリンクからお問合わせや、研究へのご参加をお待ちしております。
しつもんや けんきゅうの さんかを おまちして おります。

ディスレクシアについてくわしく見てみる（NPO EDGEのページへ）

問い合わせ（DNPのサイトの問い合わせフォームへ）
しつもん する

研究についてくわしく見てみる（朱助教のプロジェクトのページへ）
けんきゅうに ついて しる

アンケートを終おわる
    `;
  }
}
